/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CharTTLOCriteriaOutput
 */
export interface CharTTLOCriteriaOutput {
    /**
     * 
     * @type {boolean}
     * @memberof CharTTLOCriteriaOutput
     */
    exclude?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CharTTLOCriteriaOutput
     */
    value?: string;
}

export function CharTTLOCriteriaOutputFromJSON(json: any): CharTTLOCriteriaOutput {
    return CharTTLOCriteriaOutputFromJSONTyped(json, false);
}

export function CharTTLOCriteriaOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CharTTLOCriteriaOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function CharTTLOCriteriaOutputToJSON(value?: CharTTLOCriteriaOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': value.value,
    };
}


